import clsx from 'clsx';

import type { FC, HTMLAttributes } from 'react';

import s from './GroupEmptyDescription.module.css';

type GroupEmptyDescriptionProps = HTMLAttributes<HTMLHeadingElement>;

const GroupEmptyDescription: FC<GroupEmptyDescriptionProps> = ({ className, ...props }) => (
  <p className={clsx('paragraph', s.description, className)} {...props} />
);

export { GroupEmptyDescription };
